import { AppLogo } from 'layouts';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProperties, Col, Row } from 'ui';

export type HeaderItem = {
  label: string;
  onClick: () => void;
  type: ButtonProperties['type'];
};

type P = {
  items: HeaderItem[];
};

export const Header = ({ items }: P) => {
  const { t } = useTranslation();
  return (
    <Row>
      <Col className="onboarding-header__header-left" span={12}>
        <AppLogo />
      </Col>
      <Col className="onboarding-header__header-right" span={12}>
        {items.map((item, index) => (
          <Button
            {...item}
            className="onboarding-header__header-right__button"
            // eslint-disable-next-line react/no-array-index-key -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            key={`onboarding-header-${index}`}
            size="large"
          >
            {t(item.label)}
          </Button>
        ))}
      </Col>
    </Row>
  );
};
